import { MotiIcon } from "./moti-icon";
import { UUID } from "./uuid";
import { UserId } from "../../shared/models/user";

export type OptionId = string;


export interface MotiOption<T = OptionId> {
  id: T;
  name?: string;
  href?: string;
  callback?: () => void;
  icon?: MotiIcon;
  selected?: boolean;

  // Special options:
  userId?: UserId; // for rendering avatars
  teamId?: UUID; // for rendering a whole team's avatars
}


export class MotiOptionGroup<T = string> {
  /**
   * This is just a convenient place for Angular templates to store whether
   * a menu should be open or not (instead of, e.g., having to have dedicated
   * component properties tracking whether a menu should be open)
   */
  menuActive: boolean = false;
  options: MotiOption<T>[] = [];


  constructor(options?: MotiOption<T>[]) {
    if (options) {
      this.options = options;
    }
  }


  getSelected(): MotiOption<T> {
    return this.options.find(o => o.selected === true);
  }


  changeSelected(id: string, runCallback: boolean) {
    for (let option of this.options) {
      option.selected = option.id === id;
    }

    if (runCallback) {
      const selected = this.getSelected();
      const cb = selected?.callback;

      if (cb) {
        cb();
      }
    }
  }
}


export class MotiOptionGroupMultiSelect {
  /**
   * This is just a convenient place for Angular templates to store whether
   * a menu should be open or not (instead of, e.g., having to have dedicated
   * component properties tracking whether a menu should be open)
   */
  menuActive: boolean = false;
  options: MotiOption[] = [];


  constructor(options?: MotiOption[]) {
    if (options) {
      this.options = options;
    }
  }


  select(id: OptionId) {
    this.options.find(o => o.id === id).selected = true;
  }


  selectAll() {
    for (let option of this.options) {
      option.selected = true;
    }
  }


  deselect(id: OptionId) {
    this.options.find(o => o.id === id).selected = false;
  }


  deselectAll() {
    for (let option of this.options) {
      option.selected = false;
    }
  }


  getSelected(): MotiOption[] {
    return this.options.filter(o => o.selected === true);
  }


  getUnselected(): MotiOption[] {
    return this.options.filter(o => o.selected === false);
  }
}
